// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";

export const customize = (namespace) => (WrappedComponent) => {
  class Customize extends Component {
    constructor(props, context) {
      super(props, context);
    }

    getStyles = (htmlComponent) => {
      const { styles } = this.props;
      const complexHtmlComponent = htmlComponent.split(":");
      if (!styles) return {};

      if (complexHtmlComponent.length > 1) {
        if (
          styles[complexHtmlComponent[0]] &&
          styles[complexHtmlComponent[0]][complexHtmlComponent[1]]
        )
          return styles[complexHtmlComponent[0]][complexHtmlComponent[1]];
        htmlComponent = complexHtmlComponent[1];
      }

      if (styles[namespace] && styles[namespace][htmlComponent])
        return styles[namespace][htmlComponent];

      if (styles.default && styles.default[htmlComponent])
        return styles.default[htmlComponent];

      return {};
    };

    render() {
      const notAllowedProps = ["dispatch", "styles"];
      const props = Object.keys(this.props)
        .filter((key) => !notAllowedProps.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.props[key];
          return obj;
        }, {});

      return <WrappedComponent getStyles={this.getStyles} {...props} />;
    }
  }

  Customize.propTypes = {
    styles: PropTypes.object.isRequired,
  };

  const mapStateToProps = (state) => ({
    styles: state.architectureReducer.architecture.styles || {},
  });

  return connect(mapStateToProps)(Customize);
};

export const withStyle = (namespace) => (Component) => {
  function StyledComponent(props) {
    const getStyles = (htmlComponent) => {
      const { styles } = props;
      const complexHtmlComponent = htmlComponent.split(":");
      if (!styles) return {};

      if (complexHtmlComponent.length > 1) {
        if (
          styles[complexHtmlComponent[0]] &&
          styles[complexHtmlComponent[0]][complexHtmlComponent[1]]
        )
          return styles[complexHtmlComponent[0]][complexHtmlComponent[1]];
        htmlComponent = complexHtmlComponent[1];
      }

      if (styles[namespace] && styles[namespace][htmlComponent])
        return styles[namespace][htmlComponent];

      if (styles.default && styles.default[htmlComponent])
        return styles.default[htmlComponent];

      return {};
    };

    const notAllowedProps = ["dispatch", "styles"];
    const filteredProps = Object.keys(props)
      .filter((key) => !notAllowedProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = props[key];
        return obj;
      }, {});

    return <Component getStyles={getStyles} {...filteredProps} />;
  }

  StyledComponent.displayName = `withStyle_${Component.displayName}`;

  StyledComponent.propTypes = {
    styles: PropTypes.object.isRequired,
  };

  return StyledComponent;
};
